import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FontSizeDirective } from './font-size.directive';
import { ScrollToDirective } from './scroll-to.directive';
import { AppDropdownDirective } from './dropdown.directive';
import { DropdownAnchorDirective } from './dropdown-anchor.directive';
import { DropdownLinkDirective } from './dropdown-link.directive';
import { EchoSideNavToggleDirective } from './echo-side-nav-toggle.directive';
import { EchoSidenavHelperDirective, EchoSidenavTogglerDirective } from './echo-sidenav-helper/echo-sidenav-helper.directive';
import { EchoHighlightDirective } from './echo-highlight.directive';


const directives = [
  FontSizeDirective,
  ScrollToDirective,
  AppDropdownDirective,
  DropdownAnchorDirective,
  DropdownLinkDirective,
  EchoSideNavToggleDirective,
  EchoSidenavHelperDirective,
  EchoSidenavTogglerDirective,
  EchoHighlightDirective,
  
]

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: directives,
  exports: directives
})
export class SharedDirectivesModule {}